import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import classNames from "classnames";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import qs from "qs";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import {
  MuiPickersUtilsProvider,
  TimePicker,
  DatePicker
} from "material-ui-pickers";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  main: {
    width: "auto",
    display: "block", // Fix IE 11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: "auto",
      marginRight: "auto"
    }
  },
  paper: {
    marginTop: theme.spacing.unit * 7,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme
      .spacing.unit * 3}px`
  },
  textField: {
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2
  },
  dense: {
    marginTop: 16
  },
  menu: {
    width: 200
  },
  grid: {
    width: "100%"
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2
  }
});

class ConfirmInfo extends Component {
  state = {
    user: {}
  };

  async fetchGarminUserInfo({ userId }) {
    const result = await fetch(`/garmin/api/userinfo?userId=${userId}`, {
      mode: "cors",
      method: "GET"
    });

    const data = await result.json();

    if (data.success) {
      this.setState({ user: data.data });
    }
  }

  componentDidMount() {
    const userId = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true
    }).userId;
    this.fetchGarminUserInfo({ userId });
  }

  render() {
    const { classes } = this.props;

    return (
      <main className={classes.main}>
        <CssBaseline />

        <Paper className={classes.paper}>
          <Typography component="h1" variant="h5">
            個人資料
          </Typography>
          <Typography component="h2" variant="h5">
            Email {this.state.user.email}
          </Typography>
          <Typography component="h2" variant="h5">
            姓名{this.state.user.lastname}
            {this.state.user.firstname}
          </Typography>
          <Typography component="h2" variant="h5">
            手機 {this.state.user.phone}
          </Typography>
          <Typography component="h2" variant="h5">
            身份證字號 {this.state.user.identity}
          </Typography>
          <Typography component="h2" variant="h5">
            性別 {this.state.user.gender}
          </Typography>
          <Typography component="h2" variant="h5">
            生日 {this.state.user.dateofbirth}
          </Typography>
          <Typography component="h2" variant="h5">
            身高 {this.state.user.height}
          </Typography>
          <Typography component="h2" variant="h5">
            體重 {this.state.user.weight}
          </Typography>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={() =>
              (window.location.href = "https://www.garmin.com.tw/mobile/")
            }
          >
            確認
          </Button>
          {/*
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            修改
          </Button>
          */}
        </Paper>
      </main>
    );
  }
}

ConfirmInfo.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ConfirmInfo);
